import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Landing } from "./pages/Landing";
import { List } from "./pages/List";
import { Transactions } from "./pages/Transactions";
import { History } from "./pages/History";
import { SponsorList } from "./pages/SponsorList";
import { Raffle } from "./pages/Raffle";
import { AllRaffles } from "./pages/AllRaffles";
import { Coupon } from "./pages/Coupon";
import { AllCoupons } from "./pages/AllCoupons";
import { Refer } from "./pages/Refer";
import { Prizes } from "./pages/Prizes";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container } from "@mui/material";
const BialApp = /*#__PURE__*/React.memo(_ref => {
  let {
    pulse_token,
    member_id,
    source_path,
    x_api_key,
    on_signin,
    member_name
  } = _ref;
  localStorage.setItem("source_path", source_path);
  localStorage.setItem("x_api_key", x_api_key);
  const [currentRoute, setCurrentRoute] = useState(window.location.href);
  const upateScreen = screen => {
    window.location.href = "#" + screen;
  };
  useEffect(() => {
    const handleHashChange = () => {
      setCurrentRoute(window.location.href);
    };
    window.addEventListener("hashchange", handleHashChange);
    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);
  return /*#__PURE__*/React.createElement(Container, null, !currentRoute.includes("#/") && /*#__PURE__*/React.createElement(Landing, {
    onSignIn: on_signin,
    navigate: upateScreen,
    member_id: member_id,
    pulse_token: pulse_token,
    member_name: member_name
  }), currentRoute.includes("/refer") && /*#__PURE__*/React.createElement(Refer, {
    navigate: upateScreen
  }), currentRoute.includes("/transactions") && /*#__PURE__*/React.createElement(Transactions, {
    navigate: upateScreen
  }), currentRoute.includes("/history") && /*#__PURE__*/React.createElement(History, {
    navigate: upateScreen
  }), currentRoute.includes("/sponsorlist") && /*#__PURE__*/React.createElement(SponsorList, {
    navigate: upateScreen
  }), currentRoute.includes("/list") && /*#__PURE__*/React.createElement(List, {
    navigate: upateScreen
  }), currentRoute.includes("/raffle") && /*#__PURE__*/React.createElement(Raffle, {
    navigate: upateScreen
  }), currentRoute.includes("/allraffle") && /*#__PURE__*/React.createElement(AllRaffles, {
    navigate: upateScreen
  }), currentRoute.includes("/coupon") && /*#__PURE__*/React.createElement(Coupon, {
    navigate: upateScreen
  }), currentRoute.includes("/allcoupons") && /*#__PURE__*/React.createElement(AllCoupons, {
    navigate: upateScreen
  }), currentRoute.includes("/prizes") && /*#__PURE__*/React.createElement(Prizes, {
    navigate: upateScreen
  }));
});
export { BialApp };

// const onEmit=(event,)